/**
 * Sidebar-thema's als TOKENSET — één object per thema (BLOK 2). De Sidebar leest `theme.<sleutel>` i.p.v.
 * losse hardcoded kleuren, zodat BLOK 4 de keuze met één variabele kan omzetten.
 *
 * Twee ASSEN, los van elkaar:
 *   - dit SIDEBAR-thema ('orion-blauw' | 'licht') — enkel de sidebar;
 *   - de app-brede dark/light (themeStore) — de rest van de app.
 * 'orion-blauw' is bewust in béíde app-modes donkerblauw. 'licht' volgt exact de bestaande look
 * (inclusief dark:-varianten), zodat het byte-voor-byte de huidige sidebar is (veilige terugval).
 *
 * Orion-indigo (blue-600) blijft de primaire actie-accentkleur (R11); hier enkel sidebar-oppervlakken.
 */
export const SIDEBAR_THEMES = {
  'orion-blauw': {
    root: 'bg-blue-950 border-r border-blue-900',
    divider: 'border-blue-900',
    brand: 'text-white',
    brandAccent: 'text-blue-300',
    searchBtn: 'bg-blue-900/50 text-blue-100 hover:bg-blue-900',
    kbd: 'bg-blue-950 text-blue-200 border border-blue-800',
    groupIdle: 'text-blue-200/60 hover:text-blue-50 hover:bg-blue-900/40',
    groupActive: 'text-white bg-blue-900/50',
    itemIdle: 'text-blue-100/80 hover:bg-blue-900/40',
    itemActive: 'bg-blue-800/50 text-white font-medium border-l-2 border-blue-400',
    itemLocked: 'text-blue-300/50 hover:bg-blue-900/30 cursor-not-allowed',
    kopIcon: 'text-blue-100',
    balk: 'bg-blue-950',
    subIdle: 'text-blue-200/70 hover:bg-blue-900/40',
    subActive: 'bg-blue-800/50 text-white',
    subLabel: 'text-blue-300/60',
    userName: 'text-white',
    userMeta: 'text-blue-200/60',
    badge: 'bg-blue-800/60 text-blue-100',
    footerBtn: 'text-blue-100/80 hover:bg-blue-900/40',
  },
  licht: {
    root: 'bg-surface dark:bg-gray-800 border-r border-line dark:border-gray-700',
    divider: 'border-line dark:border-gray-700',
    brand: 'text-ink dark:text-white',
    brandAccent: 'text-blue-600',
    searchBtn: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600',
    kbd: 'bg-white dark:bg-gray-800 border dark:border-gray-600 text-gray-500',
    groupIdle: 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700',
    groupActive: 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20',
    itemIdle: 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700',
    itemActive: 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 font-medium border-l-2 border-blue-600 dark:border-blue-400',
    itemLocked: 'text-gray-500 dark:text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-not-allowed',
    kopIcon: 'text-gray-700 dark:text-gray-300',
    balk: 'bg-surface dark:bg-gray-800',
    subIdle: 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700',
    subActive: 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400',
    subLabel: 'text-gray-500 dark:text-gray-400',
    userName: 'text-gray-900 dark:text-gray-100',
    userMeta: 'text-gray-500 dark:text-gray-400',
    badge: 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-400',
    footerBtn: 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700',
  },
}

export const DEFAULT_SIDEBAR_THEME = 'orion-blauw'
export const SIDEBAR_THEME_IDS = Object.keys(SIDEBAR_THEMES)
